import React from "react";
import { Helmet } from "react-helmet-async";
import { parseHtml } from "helpers";

const SeomaticHelmet = ({ seomatic }) => {
  return (
    <Helmet>
      {parseHtml(seomatic.metaTitleContainer)}
      {parseHtml(seomatic.metaTagContainer)}
    </Helmet>
  );
};

export default SeomaticHelmet;
